import { useState } from "react";
import globalText from "../../../../../utils/globalText";
import Validation from "../../../../../utils/validation";
import AmountToWords from "../../../../_utils/AmountToWords";
import CommonLayout from "../../../../_utils/CommonLayout";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";

const ScheduleTransactionStepAmount = (props) => {
  const [amount, setAmount] = useState("");
  const [amountDetails, setAmountDetails] = useState(false);
  const [customAmount, setCustomAmount] = useState(false);
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [isMinimumBalanceChecked, setIsMinimumBalanceChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsMinimumBalanceChecked(checked);
    setAmountDetails(false);
    setCustomAmount(false);
    if (checked) {
      setAmount("");
    }
  };

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      props?.setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      props?.setShowRupeeSymbol(false);
      props?.setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const rawWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedWords =
        amountNumber > 0 && amountNumber <= 1
          ? rawWords.replace("rupees", "rupee")
          : rawWords;

      props?.setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedWords,
      }));

      props?.setShowRupeeSymbol(numericValue.trim() !== "");
    }
  };
  return (
    <div className="max-w-tab-width-normal w-width-full mx-auto pt-padding-md Qsmd:pt-padding-lg pb-padding-md px-padding-md lg:px-padding-base">
      <CommonLayout>
        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <Amount
            title={globalText?.TRANSFER_AMOUNT}
            amount={props?.txnPayLoad?.amount}
            amountInWords={props?.txnPayLoad?.amountInWords}
            copyData={null}
            onAmountChange={(val) =>
              handleAmountChange({ name: "amount", value: val })
            }
            onPasteApplied={() => {}}
            isPreview={false}
            txnPayLoad={props?.txnPayLoad}
          />
        </div>
        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <PaymentMethodSelector
            title={globalText?.SELECT_PAYMENT_METHOD}
            slideAnimation={true}
            methods={[
              {
                key: "neft",
                label: globalText?.NEFT,
                subText: globalText?.NEFT_TRANSFER_NOTE,
                active: !!props.isNeft,
                notes: [
                  globalText?.TRANSACTION_EXECUTION_NOTE,
                  globalText?.TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: () => {
                  if (!props.isNeft) {
                    setSlideAnimation(true);
                    setTimeout(() => setSlideAnimation(false), 100);
                  }
                  props.setIsNeft(true);
                  props.setIsImps(false);
                  props.setIsRtgs(false);
                  props.setTxnPayLoad({
                    ...props.txnPayLoad,
                    settleType: "neft",
                  });
                },
              },
              {
                key: "rtgs",
                label: globalText?.RTGS,
                subText: globalText?.INSTANT_TRANSFER_NOTE,
                active: !!props.isRtgs,
                notes: [
                  globalText?.RTGS_TRANSACTION_EXECUTION_NOTE,
                  globalText?.RTGS_TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: () => {
                  if (!props.isRtgs) {
                    setSlideAnimation(true);
                    setTimeout(() => setSlideAnimation(false), 100);
                  }
                  props.setIsNeft(false);
                  props.setIsImps(false);
                  props.setIsRtgs(true);
                  props.setTxnPayLoad({
                    ...props.txnPayLoad,
                    settleType: "rtgs",
                  });
                },
              },
            ]}
          />
        </div>
      </CommonLayout>
      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </div>
  );
};

export default ScheduleTransactionStepAmount;
